(function () {
    var $formDetails = $('form.details');
    var $formLogin = $('form.login');

    if ($formDetails.length === 0 || $formLogin.length === 0) return;

    // Form validation
    var options = {
        groupClass: 'has-error',
        groupSelector: '.form-group',
        errorPosClasses: ['.input-group', '.selectize-control'],
        helpSpanDisplay: 'help-block',
        delay: false,
        disableSubmitBtn: false,
    };

    var detailsMetrics = [
        ['select[name="title"]', 'presence', gmtrans('booking.completion.frontend_validation.title_required')],
        ['input[name="first_name"]', 'presence', gmtrans('booking.completion.frontend_validation.firstname_required')],
        ['input[name="last_name"]', 'presence', gmtrans('booking.completion.frontend_validation.lastname_required')],
        ['input[name="email"]', 'presence', gmtrans('booking.completion.frontend_validation.email_required')],
        ['input[name="phone"]', 'presence', gmtrans('booking.completion.frontend_validation.phone_required')],
        ['input[name="address1"]', 'presence', gmtrans('booking.completion.frontend_validation.address_required')],
        ['input[name="city"]', 'presence', gmtrans('booking.completion.frontend_validation.city_required')],
        ['input[name="postcode"]', 'presence', gmtrans('booking.completion.frontend_validation.postcode_required')],
        ['select[name="country"]', 'presence', gmtrans('booking.completion.frontend_validation.country_required')],
    ];

    var loginMetrics = [
        ['input[name="username"]', 'presence', gmtrans('booking.completion.frontend_validation.email_required')],
        ['input[name="password"]', 'presence', gmtrans('booking.completion.frontend_validation.password_required')],
    ];

    $formDetails.nod(detailsMetrics, options);

    var authenticated = $('#authenticated').val();

    if (!authenticated) {
        $formLogin.nod(loginMetrics, options);
    }
})();
